import Button from "@/components/forms/Button/Button";
import styles from "./current-offers.module.css";
import { Offer } from "@/api/products";
import Accordion from "@/components/Accordion/Accordion";
import { Tooltip } from "@/components/Tooltip/Tooltip";
import LoadingSpinner from "@/components/LoadingSpinner/LoadingSpinner";
import Flex from "@/components/Flex/Flex";
import StatusBadge from "@/components/StatusBadge/StatusBadge";

interface CurrentOffersProps {
  offers: Offer[];
  offersLoading: boolean;
  setPrice: (price: number) => void;
}

export default function CurrentOffers(props: CurrentOffersProps) {
  const { offers, offersLoading, setPrice } = props;

  if (offersLoading) {
    return <Flex justify="center"><LoadingSpinner /></Flex>;
  }

  const fbaOffers = [], fbmOffers = [];
  offers.forEach(offer => offer.IsFulfilledByAmazon ? fbaOffers.push(offer) : fbmOffers.push(offer));

  const Price = ({ price }: { price: number }) => (
    <div className={styles.priceBox}>
      <span className="strong">
        ${price}
      </span>
      <span>USD</span>
      <Button className={styles.selectPriceButton} type="secondary" onClick={() => setPrice(price)}>
        Set this price
      </Button>
    </div>
  );

  return (
    <Flex direction="column" className={styles.container}>
      <Accordion
        defaultExpanded={true}
        title={
          <div className={styles.row}>
            <span className={"strong"}>FBA</span>
            <div className={styles.counter}>
              {fbaOffers.length}
            </div>
          </div>
        }
      >
        <Flex direction="column">
          {fbaOffers.map((offer, i) => (
            <div className={styles.priceRow} key={i}>
              {offer.IsBuyBoxWinner && (
                <Tooltip title="This is the FBA buy-box for this item">
                  <img src="/images/buy-box.svg" width={24} height={24} alt="boxem" />
                </Tooltip>
              )}
              {offer.SellerId === "A2R2RITDJNW1Q6" && (
                <Tooltip title="Amazon is a seller on the listing">
                  <img src="/images/amazon.svg" width={24} height={24} alt="amazon" />
                </Tooltip>
              )}
              <Price price={offer.ListingPrice.Amount} />
              <StatusBadge status="success" label={offer.SubCondition} />
            </div>
          ))}
        </Flex>
      </Accordion>
      <Accordion
        defaultExpanded={true}
        title={
          <div className={styles.row}>
            <span>FBM</span>
            <div className={styles.counter}>
              {fbmOffers.length}
            </div>
          </div>
        }
      >
        <Flex direction="column">
          {fbmOffers.map((offer, i) => (
            <div className={styles.priceRow} key={i}>
              {offer.IsBuyBoxWinner && (
                <Tooltip title="This is the FBM buy-box for this item">
                  <img src="/images/buy-box.svg" width={24} height={24} alt="boxem" />
                </Tooltip>
              )}
              {offer.SellerId === "A2R2RITDJNW1Q6" && (
                <Tooltip title="Amazon is a seller on the listing">
                  <img src="/images/amazon.svg" width={24} height={24} alt="amazon" />
                </Tooltip>
              )}
              <Price price={offer.ListingPrice.Amount} />
              <StatusBadge status="success" label={offer.SubCondition} />
            </div>
          ))}
        </Flex>
      </Accordion>
    </Flex>
  );
}
